import { motion, useReducedMotion } from "framer-motion";
import { FondoVideoAmbient } from "../../shared";
import { Mariposa, Flor, FlorEdad } from "./Ilustraciones";

export default function Portada({ datos }) {
  const { protagonista, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 24 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="km-portada" data-testid="km-portada">
      <Mariposa clase="km-mariposa--1" />
      <Mariposa clase="km-mariposa--2" color="var(--km-terciario)" ala="var(--km-primario)" />
      <Flor clase="km-flor--1" />
      <Flor clase="km-flor--2" petalos="var(--km-terciario)" />
      <Flor clase="km-flor--3" petalos="var(--km-acento)" centro="var(--km-primario)" />

      <div className="km-portada-texto">
        <motion.p className="km-portada-frase" {...entrar(0.1)}>
          {protagonista.fraseIntroductoria}
        </motion.p>
        <div className="km-portada-fila">
          <motion.h1 className="km-portada-nombre" data-testid="km-nombre" {...entrar(0.25)}>
            {protagonista.nombre}
          </motion.h1>
          {protagonista.edad && (
            <motion.div {...entrar(0.4)}>
              <FlorEdad numero={protagonista.edad} texto={protagonista.textoEdad || "años"} />
            </motion.div>
          )}
        </div>
        <motion.p className="km-portada-fecha" data-testid="km-fecha" {...entrar(0.55)}>
          {evento.fechaLegible} · {evento.ciudad}
        </motion.p>
        <motion.p className="km-portada-mensaje" {...entrar(0.68)}>
          {protagonista.mensajePortada}
        </motion.p>
        {protagonista.textoBotonEntrada && (
          <motion.a href="#km-contenido" className="km-boton" data-testid="km-boton-bajar" {...entrar(0.8)}>
            {protagonista.textoBotonEntrada}
          </motion.a>
        )}
      </div>
      <motion.div className="km-portada-visual" {...entrar(0.5)}>
        <div className="km-portada-marco">
          {datos.portadaVideo?.urlYoutube ? (
            <FondoVideoAmbient
              urlYoutube={datos.portadaVideo.urlYoutube}
              poster={datos.portadaVideo.poster || fotos.portada}
            />
          ) : (
            <img
              className="km-portada-foto"
              src={fotos.portada}
              alt={`Fotografía de la fiesta de ${protagonista.nombre}`}
            />
          )}
        </div>
      </motion.div>
    </header>
  );
}
